<template>
    <div class="panel fx-g1 fx-c_stretch" v-loading="uploading" element-loading-text="上传中...">
        <div class="fx-g1 fx fx-wrap fx-m_between fx-c_start" style="padding: 20px">
            <div v-for="(item, i) in form.list" :key="i" class="pic_item">
                <img :src="item" alt="">
                <i class="iconfont icon-notpass del_btn" @click="delPic(i)"></i>
            </div>
            <div class="pic_item fx fx-m_between fx-c_stretch ">
                <div class="fx fx-center fx-g1 font18 text_primary upload_btn" @click="showLib=true"
                     style="margin-right: 15px">
                    <i class="font22 iconfont icon-yunshangchuan"></i> 从库中选择照片
                </div>
                <div class="fx fx-center fx-g1 font18 text_primary upload_btn" @click="$refs.uploadFile.click()">
                    <i class="font22 iconfont icon-yunshangchuan"></i> 从本地上传照片
                    <input type="file" ref="uploadFile" class="hide" accept="image/*" @change="upload($event)">
                </div>
            </div>
        </div>
        <div class="bottom fx fx-center font16" >
            <el-button type="primary" @click="sub">保存</el-button>
        </div>
        <BannerLibPage v-if="showLib" :is-sub="isSub" :item="form" @submit="addPicFromLib" @close="showLib=false"></BannerLibPage>
    </div>
</template>


<style scoped>
    .pic_item {
        width: 48%;
        height: 250px;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 30px;
        position: relative;
    }
    .pic_item img {
        width: 100%;
        height: 100%;
    }

    .bottom {
        height: 80px;
    }
    .bottom > * {
        margin: 0 20px;
    }
    .del_btn {
        display: inline-block;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 30px;
        color: white;
    }
    .del_btn:hover {
        color: var(--primary);
    }
    .upload_btn {
        border: 1px dashed var(--primary);
        border-radius: 10px;
        cursor: pointer;
    }

</style>

<script>

    import BannerLibPage from "./BannerLibPage";

    export default {
        props: [
            "attr",
        ],
        components: {
            BannerLibPage,
        },
        data() {
            return {
                uploading: false,
                showLib: false,
                form: { },
                config: {},
            }

        },

        computed : {
            isSub: function() {
                return this.attr != null && this.attr.subInstitution != null; //是否是子机构的界面
            },

            subId: function () {
                return (this.attr && this.attr.subInstitution) ? this.attr.subInstitution.id : 0;
            }
        },
        methods: {
            loadData() {
                let url = "";
                if (this.isSub) {
                    url = "/config/getSubInstitutionConfig/" + this.subId + "-3";
                } else {
                    url = "/config/getProgramBanner";
                }
                this.$ajaxGet(url, (data) => {
                    let form =  (data.result && data.result.value) ?  JSON.parse(data.result.value) : {};
                    if (form.list == null) {
                        form.list = [];
                    }
                    this.form = form;
                    this.config = data.result ? data.result : {};
                })
            },
            addPicFromLib(form) {
                if (form.pics && form.pics.length > 0) {
                    this.form.list.push(...form.pics);
                }
                if (Object.prototype.hasOwnProperty.call(form,"allowSubUse")) {
                    this.form.allowSubUse = form.allowSubUse;
                }
                this.showLib = false;
            },
            delPic(index) {
                this.$showConfirm("确认删除该Banner图吗", ()=> {

                    this.form.list.splice(index,  1);
                })

            },
            upload(e) {
                if (e.target.value) {
                    this.uploading = true;
                    let file = e.target.files[0];
                    this.$uploadQiniu(file, "website/", {
                            success: (file) => {
                                this.form.list.push(file.url);
                                this.uploading = false;
                            }
                        }
                    )
                }

            },

            sub() {
                let url = "";
                if (this.isSub) {
                    url = "/config/saveSubInstitutionConfig";
                } else {
                    url = "/config/saveConfig";
                }
                this.$ajaxPost(url, {
                    institutionId: this.subId,
                    config: {...this.config, type: 3, value: JSON.stringify(this.form)}
                }, data => {
                    this.$showSuccess("保存成功");
                    //这些图片加到自己的库里
                    if (this.form.list && this.form.list.length > 0) {
                        this.$ajaxPost("/dictionary/addProgramBannerLib", {
                            pics: this.form.list
                        }, (data) => {

                        }, (data)=> {
                            this.$showError("保存到库失败");
                        })
                    }
                })

                return false;
            },

        },
        mounted() {
        },
        created() {
            this.loadData() ;
        }


    }
</script>
